import React from 'react';
import moment from 'moment';

import { ListItem } from 'material-ui/List';
import MenuItem from 'material-ui/MenuItem';

import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import TickIcon from 'material-ui/svg-icons/navigation/check';
import Avatar from 'material-ui/Avatar';
import ActionInfo from 'material-ui/svg-icons/action/info-outline';
import ActionDone from 'material-ui/svg-icons/action/done';
import * as Colors from 'material-ui/styles/colors';

import NotificationActions from '../../actions/NotificationActionCreator';

const NotificationListItem = React.createClass({

    render: function() {

        const notification = this.props.data;
        const created = moment(notification.dateAdded).fromNow();
        let avatarIcon = <ActionInfo />;
        const style = {
            menu: {
                marginRight: 0,
                marginBottom: 0,
                float: 'left',
                position: 'relative',
                zIndex: 0,
            },
            menuItem: {
                color: '#CC0000',
            },
            iconButton: {
                marginRight: 0,
            },
            listItem: {
                padding: '2px',
            },
            avatar: {
                backgroundColor: Colors.red900
            }
        };

        /**
         * @TODO use constant
         */
        if(notification.statusId === 2) {
            avatarIcon = <ActionDone />;
            style.avatar.backgroundColor = Colors.green900;
        }

        return (
            <ListItem
                style={style.listItem}
                leftAvatar={
                    <Avatar
                      color={Colors.white}
                      backgroundColor={style.avatar.backgroundColor}
                      icon={avatarIcon}
                    />
                }
                primaryText={
                    notification.title
                }
                secondaryText={
                    <span>{created}</span>
                }
                rightIcon={
                    <IconMenu
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton
                                touch={true}
                            >
                                <MoreVertIcon
                                    color={Colors.grey400}
                                    style={style.iconButton}
                                />
                            </IconButton>
                        }
                    >
                        <MenuItem
                            primaryText="Mark as read"
                            value={notification.id}
                            onTouchTap={this._markAsRead.bind(this, notification.id)}
                            leftIcon={<TickIcon />}
                        />
                    </IconMenu>
                }
            />
        );
    },

    _markAsRead: function(notificationId) {
        NotificationActions.markAsRead(notificationId);
    }
});

export default NotificationListItem;
